import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react'
import styled from 'styled-components'
import axios from 'axios'

const RandomBox = forwardRef((props, ref) => {
  const { randomboxList, getPerks, edit, setEdit } = props

  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)

  useEffect(() => {
    setData(randomboxList)
  }, [randomboxList])

  useEffect(() => {
    if (data.length > 0) {
      setTotal(data.reduce((acc, item) => acc + item.percentage, 0).toFixed(2))
    }
  }, [data])

  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      }
    )
  }

  const clickAdd = async () => {
    const temp = [...data]
    temp.push({
      seq: uuidv4(),
      coin: 0,
      percentage: 0,
    })

    setData(temp)
  }

  const clickDelete = async id => {
    setData(data.filter((d, i) => d.seq !== id))
  }

  const clickSave = async () => {
    await axios
      .put(
        `/new/webAdmin/v2/perks/randombox`,
        { data },
        {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        }
      )
      .then(() => {
        getPerks()
      })
  }

  useImperativeHandle(ref, () => ({
    clickSave,
  }))

  return (
    <Wrapper>
      <Table>
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Coin</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 &&
            data.map((item, index) => {
              if (index < Math.ceil(data.length / 2)) {
                return (
                  <tr key={index}>
                    <td>
                      {edit ? (
                        <input
                          type="number"
                          value={item.coin}
                          onChange={e =>
                            setData(
                              data.map((d, i) =>
                                d.seq === item.seq
                                  ? { ...d, coin: e.target.value }
                                  : d
                              )
                            )
                          }
                        />
                      ) : (
                        item.coin
                      )}
                    </td>
                    <td>
                      {edit ? (
                        <>
                          <input
                            type="number"
                            value={item.percentage}
                            onChange={e =>
                              setData(
                                data.map((d, i) =>
                                  d.seq === item.seq
                                    ? {
                                        ...d,
                                        percentage: Number(e.target.value),
                                      }
                                    : d
                                )
                              )
                            }
                          />
                          <img
                            src="https://img.stipop.io/image/stipop/icon/close-icon.png"
                            alt=""
                            onClick={() => clickDelete(item.seq)}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '5px',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        item.percentage
                      )}
                    </td>
                  </tr>
                )
              }
            })}
        </tbody>
      </Table>
      <Table>
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Coin</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 &&
            data.map((item, index) => {
              if (index >= Math.ceil(data.length / 2)) {
                return (
                  <tr key={index}>
                    <td>
                      {edit ? (
                        <input
                          type="number"
                          value={item.coin}
                          onChange={e =>
                            setData(
                              data.map((d, i) =>
                                d.seq === item.seq
                                  ? { ...d, coin: e.target.value }
                                  : d
                              )
                            )
                          }
                        />
                      ) : (
                        item.coin
                      )}
                    </td>
                    <td>
                      {edit ? (
                        <>
                          <input
                            type="number"
                            value={item.percentage}
                            onChange={e =>
                              setData(
                                data.map((d, i) =>
                                  d.seq === item.seq
                                    ? {
                                        ...d,
                                        percentage: Number(e.target.value),
                                      }
                                    : d
                                )
                              )
                            }
                          />
                          <img
                            src="https://img.stipop.io/image/stipop/icon/close-icon.png"
                            alt=""
                            onClick={() => clickDelete(item.seq)}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '5px',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        item.percentage
                      )}
                    </td>
                  </tr>
                )
              }
            })}
        </tbody>
      </Table>
      <Table>
        <thead>
          <tr>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                fontWeight: 'bold',
                color: total > 100 ? '#dc143c' : '#000',
              }}
            >
              {total}
              {edit && (
                <ButtonWrapper>
                  <button
                    style={{ backgroundColor: '#007ffb' }}
                    onClick={() => clickAdd()}
                  >
                    코인 추가
                  </button>
                </ButtonWrapper>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </Wrapper>
  )
})

export default RandomBox

const Wrapper = styled.div`
  width: 100%;
  margin-left: 10px;
  display: flex;
`

const Table = styled.table`
  width: 100%;

  thead {
    border-top: 1px solid #f4f4f4;
    border-bottom: 2px solid #f4f4f4;

    tr > th {
      padding: 3px;
    }
  }

  tbody {
    tr > td {
      padding: 3px 6px;
    }

    input {
      max-width: 100px;
    }
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  column-gap: 5px;

  button {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    color: #fff;
    border-radius: 5px;
    border: none;
    font-size: 16px;

    &:hover {
      opacity: 0.8;
      font-weight: bold;
    }
  }
`
